import { render, staticRenderFns } from "./DynamicConfirmation.vue?vue&type=template&id=1123db64&scoped=true&"
import script from "./DynamicConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DynamicConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicConfirmation.vue?vue&type=style&index=0&id=1123db64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123db64",
  null
  
)

export default component.exports